import http from './http'
import { isHtmlApiResponse } from './error'

function assertJsonApiResponse(response, action) {
  if (isHtmlApiResponse(response)) {
    throw new Error(
      `${action}被静态页面拦截：请确认 Nginx 已将 /api/ 反代到网关，或设置 VUE_APP_API_BASE 为真实 API 地址`
    )
  }
  const data = response?.data
  if (typeof data === 'string') {
    throw new Error(`${action}响应格式异常，请检查 API 地址与 Nginx 配置`)
  }
}

export function fetchCaptcha() {
  // 避免浏览器/网关返回 304 空 body，导致 captchaId 解析失败
  return http
    .get('/auth/captcha', {
      params: { t: Date.now() },
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
    })
    .then((response) => {
      assertJsonApiResponse(response, '验证码接口')
      return response
    })
}

export function login(mobile, password, captchaId, captchaCode) {
  return http.post('/auth/login', { mobile, password, captchaId, captchaCode })
}

export function logout() {
  return Promise.resolve()
}
